import React from "react";
import { connect } from "react-redux";

import classes from "./Home.module.css";
import Widget from "./Widget";
import Spinner from "../UI/Spinner";

import { getHomeVideos } from "../../Actions/index";

class Row extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      left: false,
      right: true
    };
    this.RowRef = React.createRef();
  }

  scroll = dir => {
    const content = this.RowRef.current;
    const preVal = content.scrollLeft;
    let nextVal;
    // if I pressed right then add 300 px else -300 px from scroll(left, top);
    if (dir === "right") {
      nextVal = preVal + 215;
      content.scroll(nextVal, 0);
    } else {
      nextVal = preVal - 215;
      content.scroll(nextVal, 0);
    }

    // if content scroll Left is > 200 then show left btn
    // else don't show
    // if it's greater than or equal to whole with - 200 then hide right
    // else show it too;

    if (nextVal > 200) this.setState({ left: true });
    else this.setState({ left: false });
    if (nextVal >= content.scrollWidth - 220) this.setState({ right: false });
    else this.setState({ right: true });
  };

  getWidgets() {
    let widgets = [];
    if (
      this.props.rowData &&
      this.props.rowData.length > 0 &&
      this.props.loading === false
    ) {
      widgets = this.props.rowData.map((video, i) => (
        <Widget
          views={video.statistics.viewCount}
          duration={video.contentDetails.duration}
          snip={video.snippet}
          videoId={video.id}
          channelId={video.snippet.channelId}
          key={i}
        />
      ));
    } else widgets = <Spinner style={{ margin: "10px auto" }} isMini={true} />;
    return widgets;
  }

  render() {
    return (
      <div className={classes.Row}>
        <div
          className={classes.LeftScrollBtn}
          onClick={() => this.scroll("left")}
          style={{ display: this.state.left ? "inline-block" : "none" }}
        >
          <div>
            <svg
              viewBox="0 0 24 24"
              preserveAspectRatio="xMidYMid meet"
              focusable="false"
            >
              <g>
                <path d="M15.41 7.41L14 6l-6 6 6 6 1.41-1.41L10.83 12z" />
              </g>
            </svg>
          </div>
        </div>
        <div className={classes.Header}>
          <h4>
            {this.props.title}{" "}
            <span className={classes.RowExtraInfo}>- Topic</span>
          </h4>
          <div className={classes.RowExtraInfo}>Recomended videos</div>
        </div>

        <div className={classes.Content} ref={this.RowRef}>
          {this.getWidgets()}
        </div>
        <div
          className={classes.RightScrollBtn}
          onClick={() => this.scroll("right")}
          style={{ display: this.state.right ? "inline-block" : "none" }}
        >
          <div>
            <svg
              viewBox="0 0 24 24"
              preserveAspectRatio="xMidYMid meet"
              focusable="false"
            >
              <g>
                <path d="M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z" />
              </g>
            </svg>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state, props) => {
  return {
    rowData: state.home.data[props.title].data,
    loading: state.home.data[props.title].loading
  };
};

export default connect(
  mapStateToProps,
  { getHomeVideos }
)(Row);
